export default __webpack_public_path__ + "static/media/monitor.e646c0ba.svg";